import { render, staticRenderFns } from "./PopupEditResponsiblePerson.vue?vue&type=template&id=40b34f4f"
import script from "./PopupEditResponsiblePerson.vue?vue&type=script&lang=ts"
export * from "./PopupEditResponsiblePerson.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports